import { inject, observer } from "mobx-react";
import React from "react";
import { useToast } from "randmarcomps";
import { RootStore } from "../stores/rootStore";

interface IProps {
  store?: RootStore;
  children?: React.ReactNode;
}

const SnackProvider: React.FC<IProps> = ({ store, children }) => {
  const { toast } = useToast();
  const seenSnackIds = React.useRef(new Set<string>());

  React.useEffect(() => {
    if (!store) return;
    const { snacks } = store.snackStore;
    if (!snacks.length) return;

    snacks.forEach((snack) => {
      const id = snack.messageId;
      if (!id || seenSnackIds.current.has(id)) return;
      seenSnackIds.current.add(id);

      const variant =
        snack.variant === "success"
          ? ("success" as const)
          : snack.variant === "error"
            ? ("destructive" as const)
            : undefined;

      toast({
        variant,
        title:
          snack.variant === "success"
            ? "Success"
            : snack.variant === "error"
              ? "Error"
              : snack.variant === "warning"
                ? "Warning"
                : "Info",
        description: snack.message,
      });

      store.snackStore.remove(snack);
    });
  }, [store, store?.snackStore.snacks.length, toast]);

  return (
    <>
      {children}
    </>
  );
};

export default inject("store")(observer(SnackProvider));
